// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"cf98a9d8","359":"c6ba77d0","442":"e2fe454d","453":"f7cb852f","605":"075333cc"}[chunkId] + ".chunk.js";
};